import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import PrimaryButton from '../../../../components/PrimaryButton'
import SecondaryButton from '../../../../components/SecondaryButton'
import {TierLabel} from '../../../../types/constEnums'
import {Dialog} from '../../../../ui/Dialog/Dialog'
import {DialogActions} from '../../../../ui/Dialog/DialogActions'
import {DialogContent} from '../../../../ui/Dialog/DialogContent'
import {DialogTitle} from '../../../../ui/Dialog/DialogTitle'








const TeamPrivacyConfirmModal = (props) => {
  const {isOpen, teamName, onClose, onConfirm} = props

  return (
    _jsx(Dialog, { isOpen: isOpen, onClose: onClose, children: 
      _jsxs(DialogContent, { className: "w-[400px] p-4" , children: [
        _jsx(DialogTitle, { children: "Make team public?"  })
        , _jsxs('div', { className: "my-4 text-slate-700" , children: [
          _jsxs('p', { children: ["You're about to make "
                , _jsx('b', { children: teamName}), " public. This means:"
          ]})
          , _jsxs('ul', { className: "mt-2 list-disc pl-5"  , children: [
            _jsx('li', { children: "Anyone in your organization can find and join this team"         })
            , _jsxs('li', { children: ["This action "
                , _jsx('b', { children: "cannot be undone"  }), " on the Starter Plan"
            ]})
            , _jsxs('li', { children: ["You would need to upgrade to the "
                     , TierLabel.TEAM, " or "  , TierLabel.ENTERPRISE, " Plan to make it private again"

            ]})
          ]})
          , _jsx('p', { className: "mt-2", children: "Are you sure you want to continue?"      })
        ]})
        , _jsxs(DialogActions, { children: [
          _jsx(SecondaryButton, { onClick: onClose, children: "Cancel"})
          , _jsx(PrimaryButton, { className: "ml-4", onClick: onConfirm, children: "Make Team Public"

          })
        ]})
      ]})
    })
  )
}

export default TeamPrivacyConfirmModal
